"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LocationItemModule = /** @class */ (function () {
    function LocationItemModule() {
    }
    return LocationItemModule;
}());
exports.LocationItemModule = LocationItemModule;
